<template>
  <v-dialog v-model="visible" max-width="700px">
    <v-card>
      <v-card-title class="text-uppercase">{{ titulo }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                class="my-1"
                label="Código"
                v-model="form.codigo"
                placeholder="Código"
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.codigo" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-text-field
                class="my-1"
                label="Nombre"
                v-model="form.nombre"
                placeholder="Nombre"
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" style="padding-bottom: 0px !important">
              <v-textarea
                class="my-1"
                label="Descripción"
                v-model="form.descripcion"
                placeholder="Nombre"
                rows="3"
                outlined
                dense
                hide-details></v-textarea>

              <small v-for="error in errores.descripcion" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col>
              <v-select
                :items="gruposPadre"
                label="Grupo Padre"
                item-text="text"
                item-value="value"
                v-model="form.grupo_id"
                outlined
                dense
                clearable
                hide-details />

              <small v-for="error in errores.grupo_id" :key="error" class="text-danger">{{ error }}</small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="validar"> Guardar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import ModalFormMixin from '../mixins/modal-form-mixin';
import GruposServices from '../services/grupo';
import { formatearErrores } from '../utils';

export default {
  name: 'ModalFormGrupo',
  mixins: [ModalFormMixin],
  data() {
    return {
      gruposPadre: [],
    };
  },
  watch: {
    'form.codigo': function () {
      this.errores.codigo = [];
    },
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.descripcion': function () {
      this.errores.descripcion = [];
    },
    'form.grupo_id': function () {
      this.errores.grupo_id = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        nombre: null,
        descripcion: null,
        grupo_id: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        nombre: data.nombre,
        descripcion: data.descripcion,
        grupo_id: data.grupo_id,
      };
    },
    abrir(accion, data = []) {
      this.obtenerGruposPadre();
      this.abrirMixin(accion, data);
    },
    async registrar() {
      this.guardar();
    },
    async editar() {
      this.guardar();
    },
    async guardar() {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;

        if (this.form?.id) {
          response = await GruposServices.update(this.form.id, this.form);
        } else {
          response = await GruposServices.store(this.form);
        }

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
    async obtenerGruposPadre() {
      try {
        const { data } = await GruposServices.getPadres();
        const gruposPadre = data.datos;

        this.gruposPadre = gruposPadre.map((grupo) => ({
          text: `${grupo.codigo} ${grupo.nombre}`,
          value: grupo.id,
        }));
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>